import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const restoreToRecommendedPlanTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "restoreToRecommendedPlan",
    src: "restoreToRecommendedPlan",
    onDone: [
      {
        target: "#StudyPlan.teacher_view",
        cond: ctx => ctx.selfRefScope.scope === "TEACHER",
        actions: assign<Context, DoneInvokeEvent<any>>((_ctx, _evt) => ({
          recommendedStudyPlan: null
        }))
      },
      {
        target: "#StudyPlan.get_current_plan",
        actions: assign<Context, DoneInvokeEvent<any>>((ctx, _evt) => ({
          recommendedStudyPlan: null
        }))
      }
    ],
    onError: {
      target: "#StudyPlan.review_plan",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, _evt) => ({
          message: getServiceErrorMessage("restoreRecommendedPlan", {
            messageData: ["restore recommended study plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
